import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const EntertainmentsTypes = ({ form, entertainmentsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Аудио/Видео/Развлечения">
      {getFieldDecorator('entertainment_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {entertainmentsTypes &&
            entertainmentsTypes.map(type => (
              <Option
                key={type.entertainmentKey}
                value={type.entertainmentKey}
                label={type.entertainmentName}
              >
                {type.entertainmentName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(EntertainmentsTypes, [
  'entertainmentsTypes',
]);
